import React, { useEffect, useState } from "react";
import { getPaySheetPreview } from "../../../services/karkhanaApi";
import { rupees } from "../rates/rateModel";
import { useKT } from "../i18n/kt";

const money = (v?: string | null) => (v && Number(v) !== 0 ? rupees(v, 0) : "—");

/**
 * Desktop: the week as the pay sheet would show it, before making one. Loom work and time + job
 * work, the suggested advance cut and what is left to hand over; Pay opens the person's account.
 */
const PayWeekTable = ({ from, to, refreshKey, onPay }: { from: string; to: string; refreshKey: number; onPay: (p: { id: string; code: string; name: string }) => void }) => {
  const { t } = useKT();
  const [data, setData] = useState<any>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setData(null);
    setFailed(false);
    getPaySheetPreview(from, to)
      .then((res: any) => (res?.success ? setData(res.data) : setFailed(true)))
      .catch(() => setFailed(true));
  }, [from, to, refreshKey]);

  if (failed) return <div className="kw-empty">{t("Could not work out the week. Try again in a moment.")}</div>;
  if (!data) return <div className="kw-empty">{t("Loading…")}</div>;
  const lines: any[] = data.lines || [];
  if (!lines.length) return <div className="kw-empty">{t("Nobody to pay for these days yet.")}</div>;
  const totals = data.totals || {};
  return (
    <div className="kd-table-wrap">
      <table className="kd-table kpy-table">
        <thead>
          <tr>
            <th scope="col">{t("Code")}</th>
            <th scope="col">{t("Name")}</th>
            <th scope="col" className="is-num">
              {t("Loom work")}
            </th>
            <th scope="col" className="is-num">
              {t("Time + job")}
            </th>
            <th scope="col" className="is-num">
              {t("Advance cut")}
            </th>
            <th scope="col" className="is-num">
              {t("Net due")}
            </th>
            <th scope="col" aria-label={t("Pay")} />
          </tr>
        </thead>
        <tbody>
          {lines.map((l) => (
            <tr key={l.personId} className={l.paid ? "is-saved" : ""}>
              <th scope="row" className="kw-code">
                {l.code}
              </th>
              <td>{l.name}</td>
              <td className="is-num">
                {Number(l.periodLoom) ? money(l.periodLoom) : l.issues ? "" : "—"}
                {l.issues ? <span className="kd-chip is-warn kpy-chip">{t(l.issues === 1 ? "1 not counted" : "{{n}} not counted", { n: l.issues })}</span> : null}
              </td>
              <td className="is-num">{money(l.periodTimeJob)}</td>
              <td className="is-num">{Number(l.cut) ? `−${rupees(l.cut, 0)}` : "—"}</td>
              <td className="is-num">
                <strong>{money(l.netDue)}</strong>
              </td>
              <td>
                {Number(l.netDue) > 0 ? (
                  <button type="button" className="kd-btn kd-btn--xs" onClick={() => onPay({ id: l.personId, code: l.code, name: l.name })}>
                    {t("Pay")}
                  </button>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th scope="row" colSpan={2}>
              {t("Total · {{n}} people", { n: lines.length })}
            </th>
            <td className="is-num">{money(totals.periodLoom)}</td>
            <td className="is-num">{money(totals.periodTimeJob)}</td>
            <td className="is-num">{Number(totals.cut) ? `−${rupees(totals.cut, 0)}` : "—"}</td>
            <td className="is-num">
              <strong>{money(totals.netDue)}</strong>
            </td>
            <td />
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default PayWeekTable;
